import { render, staticRenderFns } from "./vendors-products.vue?vue&type=template&id=1bb6c8d8"
import script from "./vendors-products.vue?vue&type=script&lang=js"
export * from "./vendors-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports